import { NextIntlClientProvider } from "next-intl";

import { useScreen0Language } from "@/features/language/language-provider";
import { getLocaleMessages } from "@/i18n/messages";

export function Screen0IntlProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { languageCode } = useScreen0Language();

  return (
    <NextIntlClientProvider
      key={languageCode}
      locale={languageCode}
      messages={getLocaleMessages(languageCode)}
    >
      {children}
    </NextIntlClientProvider>
  );
}
